var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"color":"primary","rounded":"","text":""},on:{"click":function($event){return _vm.onClick()}}},on),[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.label)))])])}
var staticRenderFns = []

export { render, staticRenderFns }